module.exports = __webpack_public_path__ + "img/a2.e884aa5b.jpg";